/**
 * The `Client-Info` header apps/web sends on every API request.
 *
 * Format is the one every other client already uses,
 * `<client>/<target>-<arch>/<semver>`, and it is parsed by the same
 * `parseClientInfoHeader` on the server. That shared parse is the whole reason
 * the browser sends one at all: the funnel derives `platform` from it, so web,
 * desktop, iOS and Android are identified by ONE mechanism, and a request with
 * no header can be recognised as what it actually is — a machine integration
 * (SaaS key, MCP connector, rails_api), not a person on the website.
 *
 * `browser-universal` because every visitor gets the same deployed build; there
 * is no per-OS or per-arch web artifact to distinguish.
 *
 * The version is a literal rather than a build-time injection because
 * `apps/web/package.json` is not bumped per release — the deployed build is
 * whatever `web-v<tag>` shipped, which this number cannot know. It is kept
 * honest by `web-client-info.test.ts`, which fails if it ever stops matching
 * the package version. Nothing depends on the value: no `web` version policy
 * exists, and `clientVersionEnforcement` fails open without one.
 */
export const WEB_CLIENT_VERSION = '0.0.1'

export const CLIENT_INFO_HEADER = 'Client-Info'

export const WEB_CLIENT_INFO = `web/browser-universal/${WEB_CLIENT_VERSION}`

/** The header pair, for anything building its own request. */
export function webClientInfoHeaders(): Record<string, string> {
  return { [CLIENT_INFO_HEADER]: WEB_CLIENT_INFO }
}
